import { useEffect, useState } from "react";
import ModalImg from "assets/images/IMG_20220311_170947_345.png";
import sendRequest from "hooks/useAxios";
import Swal from "sweetalert2";
import AuthContext from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";
import { connection } from "utils/apiConnection.ts";
import BusinessContext from "context/BusinessContext";

// import { USER_TYPE } from "constants/constants.js";
export default function LogInNumber({
  ChangeModal,
  loginkey,
  isNew,
  SetNumber,
  number,
  name,
  SetName,
  beforeJoinClub,
}) {
  const [code, setcode] = useState("");
  const { setLogbeforejoin } = useContext(BusinessContext);
  const auth = useContext(AuthContext);
  let SetCode = (e) => {
    setcode(e.target.value);
  };

  useEffect(() => {
    (() => {
      "use strict";

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.querySelectorAll(".needs-validation");
      // Loop over them and prevent submission
      Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener(
          "submit",
          (event) => {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            event.preventDefault();
            form.classList.add("was-validated");
          },
          false
        );
      });
    })();
  }, []);

  let SendCode = () => {
    connection("login", {
      mobile: number,
      hashcode: loginkey,
      code,
      fullname: name,
    }).then((data) => {
      if (data.status == 1) {
        auth.login(data.data.usertoken, data.userinfo);
        document.querySelector("#CloseModal").click();
        document.querySelector("#open-login-modal").click();

        Swal.fire({
          title: "خوش آمدید",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });

        ChangeModal(0);
      } else if (data.status == 0) {
        Swal.fire({
          title: "خطا!",
          text: "لطفا دوباره امتحان کنید",
          type: "error",
          confirmButtonText: "باشه",
        });
      } else {
        Swal.fire({
          title: "خطا!",
          text: "شما مجاز نیستید",
          type: "error",
          confirmButtonText: "باشه",
        });
      }
    });
  };
  useEffect(() =>      console.log("isnewwww", isNew), [isNew])
  // console.log("beforejoinclub", beforeJoinClub);
  return (
    <form className="needs-validation" noValidate onSubmit={SendCode}>
      <div className="modal-body text-center">
        <h1
          width="200px"
          className="my-4 text-white"
          style={{
            backgroundColor: "#383bd9",
            padding: "15px",
            borderRadius: "7px",
          }}
        >
          تات کلاب
        </h1>
        <h5>ورود یا ثبت نام در تات کلاب</h5>
        <label htmlFor="number" className="mb-4 my-3 text-muted">
          برای ورود به تات کلاب کد دریافتی را وارد کنید
        </label>
        {isNew == 1 &&
          <input
          onChange={SetName}
          value={name}
          type="text"
          style={{ height: "50px", borderRadius: "15px", direction: "rtl" }}
          id="name"
          placeholder="نام و نام خانوادگی (ضروری)"
          className="form-control w-75 mx-auto my-2"
          required
        />}
        {/* {!isnameValid && (
          <div
            style={{
              color: "red",
              fontSize: "12px",
              textAlign: "right",
              margin: "5px 60px 0px 0px",
            }}
          >
            نام را وارد کنید
          </div>
        )}  */}
        <input
          onChange={SetCode}
          value={code}
          type="number"
          style={{
            height: "50px",
            borderRadius: "15px",
            direction: "ltr",
            fontFamily: "digits",
          }}
          id="number"
          placeholder="کد دریافتی"
          className="form-control w-75 mx-auto"
          required
        />
        <div
          className="invalid-feedback text-start"
          style={{ marginRight: "63px" }}
        >
          لطفا کد دریافتی را وارد کنید
        </div>
        <label
          htmlFor="number"
          className="text-start  d-block my-3"
          style={{ marginRight: "63px", color: "#383bd9" }}
        >
          کد دریافتی را وارد کنید
        </label>
        {beforeJoinClub ? (
          <button
            type="submit"
            style={{
              height: "50px",
              borderRadius: "15px",
              backgroundColor: "#383bd9",
              color: "white",
            }}
            className="btn my-3 w-75"
            onClick={(e) => setLogbeforejoin(true)}
          >
            ارسال
          </button>
        ) : (
          <button
            type="submit"
            style={{
              height: "50px",
              borderRadius: "15px",
              backgroundColor: "#383bd9",
              color: "white",
            }}
            className="btn my-3 w-75"
          >
            ارسال
          </button>
        )}
      </div>
    </form>
  );
}
